import type { ActivityModule } from '../../core/activity';
import { mountGuessNumber } from './ui';
import levelsData from './levels.json';
import './style.css';

export const guessNumber: ActivityModule = {
  id: 'guessnumber',
  title: 'Adivinhe o número',
  description: 'Adivinhe o número secreto. A cada palpite, dizem se é maior ou menor.',
  ageMin: 7,
  ageMax: 11,
  difficulty: 3,
  iconPath: 'assets/gcompris-AGPL/guessnumber/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountGuessNumber,
};
